import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';

export function isSubscribedTo(channel) {
  return Boolean(_.get(channel, 'dgsInfo.subscription'));
}

export function isSubscriptionEnabled(channel) {
  return Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo));
}

export function getDealInfo(props) {
  return _.get(props, 'channelData.dealInfo');
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/channel/pricing.js